const Filters = {
  status: 'Unacknowledged',
  before: '',
  after: '',
  skip: 1,
  sort: '-updated_at',
  prisonId: '',
  limit: 10,
};

const FILTERS_KEY = 'post-reply-filters';

export default {
  namespaced: true,
  state: {
    filters: { ...Filters },
  },
  getters: {},
  mutations: {
    SET_FILTERS(state, value) {
      state.filters = value;

      localStorage.setItem(FILTERS_KEY, JSON.stringify(state.filters));
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;
      console.log('fitlers', state.filters);

      localStorage.setItem(FILTERS_KEY, JSON.stringify(state.filters));
    },
  },
  actions: {
    setFiltersToDefault({ commit }) {
      commit('SET_FILTERS', { ...Filters });
    },
    setFiltersFromLocal({ commit }) {
      const filters = localStorage.getItem(FILTERS_KEY);

      if (filters) {
        commit('SET_FILTERS', JSON.parse(filters));
      }
    },
    clearFilters({ commit }) {
      localStorage.removeItem(FILTERS_KEY);
      commit('SET_FILTERS', { ...Filters });
    },
  },
};
